var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondPodium = function SvgSecondPodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 22,
    fill: "#0C0C0F",
    fillOpacity: 0.4,
    rx: 8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "second-podium_svg__a",
    width: 16,
    height: 16,
    x: 6,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6 3h16v16H6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#second-podium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#second-podium_svg__b)",
    d: "M10.928 4.793h6.143v4.743q0 .27-.137.541a1.07 1.07 0 0 1-.384.426l-2.253 1.708.396 1.292h2.11l-1.741 1.226.678 2.133L14 15.54l-1.74 1.322.677-2.138-1.74-1.22h2.11l.395-1.293-2.265-1.695a1.1 1.1 0 0 1-.376-.431 1.2 1.2 0 0 1-.133-.549zm.866.867v3.876a.4.4 0 0 0 .04.185.3.3 0 0 0 .14.123l1.592 1.153V5.66zm4.41 0h-1.771v5.337l1.592-1.153q.117-.051.148-.123a.5.5 0 0 0 .032-.185z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#second-podium_svg__c)",
    d: "M32.396 16H26.9v-1.032l2.736-2.52q.588-.54.984-1.14.396-.612.396-1.224V9.94q0-.696-.384-1.128t-1.164-.432q-.384 0-.672.108t-.504.3q-.204.192-.348.456-.132.252-.216.552l-.9-.348q.12-.372.324-.72.216-.36.528-.636a2.6 2.6 0 0 1 .768-.444q.456-.168 1.068-.168t1.092.18.804.504.492.768q.18.444.18.984 0 .492-.144.912-.132.42-.372.804-.24.372-.588.732-.336.36-.732.72l-2.256 2.028h4.404zm5.143-5.112-1.008-1.86h-.036V16h-.984V7.624h1.164l3.06 5.112 1.008 1.86h.036V7.624h.984V16H40.6zm7.657-3.264h2.808q.78 0 1.416.264t1.08.792q.456.516.696 1.308.24.78.24 1.824t-.24 1.836q-.24.78-.696 1.308a2.84 2.84 0 0 1-1.08.78 3.7 3.7 0 0 1-1.416.264h-2.808zm2.808 7.488q.516 0 .948-.168a2.1 2.1 0 0 0 .744-.516q.312-.336.48-.816.18-.492.18-1.116v-1.368q0-.624-.18-1.104a2.3 2.3 0 0 0-.48-.828 2 2 0 0 0-.744-.504 2.4 2.4 0 0 0-.948-.18h-1.8v6.6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "second-podium_svg__b",
    x1: 14,
    x2: 14,
    y1: 4.793,
    y2: 16.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "second-podium_svg__c",
    x1: 39.5,
    x2: 39.5,
    y1: 2,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))));
};
export default SvgSecondPodium;